import { useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import { moduleClientFactory } from '../../../../api-service/module-client-factory';
import { ClassroomDto } from '../../../../api-service/clients/auto-generated-clients';

const attendanceClient = moduleClientFactory.createAttendanceClient();

export function useCompanyClassrooms(companyId: string) {
  const { enqueueSnackbar } = useSnackbar();
  const [classrooms, setClassrooms] = useState<ClassroomDto[]>([]);
  const [isLoadingClassrooms, setIsLoadingClassrooms] = useState(true);

  useEffect(() => {
    attendanceClient
      .getClassRoomsByCompanyId({ companyId })
      .then(response => setClassrooms((response.classRooms ?? []).filter(classroom => classroom.isActive && !classroom.isDeleted)))
      .catch(() => enqueueSnackbar('Der skete en fejl ved hentning af lokaler', { variant: 'error' }))
      .finally(() => setIsLoadingClassrooms(false));
  }, [companyId]);

  return { classrooms, isLoadingClassrooms };
}
